/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HostCodeMetadata
 */
export interface HostCodeMetadata {
    /**
     * 
     * @type {string}
     * @memberof HostCodeMetadata
     */
    host_name: string;
    /**
     * 
     * @type {number}
     * @memberof HostCodeMetadata
     */
    day_pass_days: number;
}

/**
 * Check if a given object implements the HostCodeMetadata interface.
 */
export function instanceOfHostCodeMetadata(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "host_name" in value;
    isInstance = isInstance && "day_pass_days" in value;

    return isInstance;
}

export function HostCodeMetadataFromJSON(json: any): HostCodeMetadata {
    return HostCodeMetadataFromJSONTyped(json, false);
}

export function HostCodeMetadataFromJSONTyped(json: any, ignoreDiscriminator: boolean): HostCodeMetadata {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'host_name': json['host_name'],
        'day_pass_days': json['day_pass_days'],
    };
}

export function HostCodeMetadataToJSON(value?: HostCodeMetadata | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'host_name': value.host_name,
        'day_pass_days': value.day_pass_days,
    };
}

